import React, {useEffect} from "react";
import {IBannerAd} from '../../utils/types';
import {renderAds} from "../../utils/ad-banners";
import DummyAd from "../DummyAd";
import {enviromentTypes} from "../../utils/helpers";

interface IProps {
  bannerInfo: IBannerAd | null
  isMobile: Boolean
}

const AdBanner: React.FC<IProps> = ({bannerInfo, isMobile}) => {

  const isProd = (process.env.NODE_ENV === enviromentTypes.production)

  useEffect(() => {
    if (isProd) {
      renderAds(isMobile, bannerInfo)
    }
  }, [bannerInfo, isMobile, isProd]);

  return (
    <>
      {isProd ? (
        (isMobile && bannerInfo?.bannerBodyMobile && bannerInfo.bannerHeaderMobile) || (!isMobile && bannerInfo?.bannerBody && bannerInfo.bannerHeader) ? (
          <>
            <div id={'header-' + bannerInfo?.widgetBuilderComponentId.toString()}>
            </div>
            <div id={'body-' + bannerInfo?.widgetBuilderComponentId.toString()}>
            </div>
          </>
        ) : <></>
      ) : (
        <>
          <DummyAd />
        </>
      )}

    </>
  )
}

export default AdBanner;
